export default "__VITE_ASSET__BJiFSbMP__"